/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';
import {
  Typography,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
  Button,
  Grid,
  Popover,
  Tooltip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
  TextField,
  InputAdornment,
  Modal,
} from '@material-ui/core';
import moment from 'moment';
import $ from 'jquery';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { Broker, CentrisRoom, CentrisListing as Listing, CentrisListingPicture } from 'models';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useLanguage } from 'hooks';
import { getColorContrastRatio, getPhoneNumberWithFormatting } from 'utils';
import MeetingRoomRoundedIcon from '@material-ui/icons/MeetingRoomRounded';
import KingBedRoundedIcon from '@material-ui/icons/KingBedRounded';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RoomIcon from '@material-ui/icons/Room';
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import RemoveRoundedIcon from '@material-ui/icons/RemoveRounded';
import ShareIcon from '@material-ui/icons/Share';
import {
  faBath,
  faRulerCombined,
  faCalendar,
  faToilet,
  faCamera,
  faPhone,
  faEnvelope,
  faGlobe,
  faChevronDown,
} from '@fortawesome/free-solid-svg-icons';
import {
  faFacebook,
  faYoutube,
  faLinkedinIn,
  faInstagram,
  faTwitter,
} from '@fortawesome/free-brands-svg-icons';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip as PieTooltip, Sector } from 'recharts';
import { HvGoogleMap, HvSelect } from 'components';
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
  WhatsappShareButton,
  WhatsappIcon,
} from 'react-share';
import { COLOR, COLOR_CONTRAST_RATIO, ENG } from 'config/constants';
import { isMobile } from 'utils/screen';
import { ImageCarousel, ImagesGallery, NotFound } from './index';

const useStyles = makeStyles({
  content: {
    width: '100%',
    height: '100%',
    margin: '-50px auto 50px',
    flexDirection: 'column',
    display: 'flex',
    overflowX: 'hidden',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '80%',
    marginBottom: 20,
  },
  bannerImage: {
    width: '100%',
    cursor: 'pointer',
    height: 'calc(70vh - 80px)',
    objectFit: 'cover',
    alignSelf: 'center',
    '@media (max-width: 700px)': {
      height: 400,
    },
  },
  bannerSmallImage: {
    width: '100%',
    cursor: 'pointer',
    height: 'calc((70vh - 84px) / 2)',
    marginLeft: 4,
    objectFit: 'cover',
    alignSelf: 'center',
  },
  bannerImageContainer: {
    width: '100%',
    height: '100%',
    position: 'relative',
    objectFit: 'cover',
    '@media (max-width: 700px)': {
      height: 400,
    },
  },
  overlay: {
    position: 'absolute',
    zIndex: 2,
    bottom: 10,
    left: 0,
    width: '100%',
    height: 400,
    backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5))',
  },
  detailContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  address: {
    fontSize: 18,
    alignItems: 'center',
    fontFamily: 'FordAntenna-Medium',
  },
  price: {
    marginTop: 20,
    marginBottom: 20,
    fontSize: 30,
    fontFamily: 'FordAntenna-Medium',
    color: COLOR.RED,
  },
  propertyType: {
    fontFamily: 'FordAntenna-SemiBold',
    fontSize: 20,
    marginTop: 20,
    marginBottom: 20,
  },
  card: {
    padding: 30,
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 10,
    width: '80%',
    margin: 'auto',
    backgroundColor: COLOR.ULTRA_LIGHT_PURPLE,
    maxHeight: 350,
    overflowY: 'auto',
  },
  openHousesContent: {
    padding: 30,
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 10,
    width: '80%',
    margin: 'auto',
    marginBottom: 20,
  },
  openHouseTitle: {
    fontFamily: 'FordAntenna-SemiBold',
    fontSize: 20,
    marginBottom: 10,
  },
  cardTitle: {
    fontFamily: 'FordAntenna-SemiBold',
    fontSize: 20,
    marginBottom: 20,
  },
  transparentCard: {
    padding: 30,
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 10,
    width: '80%',
    margin: 'auto',
  },
  iconRow: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    alignSelf: 'center',
    marginBottom: 20,
    '@media (max-width: 767px)': {
      width: '100%',
    },
  },
  roomCountText: {
    fontSize: 14,
    alignSelf: 'center',
    textTransform: 'revert',
    lineHeight: 1.5,
  },
  arrowIcon: {
    marginLeft: 10,
  },
  buttonIcon: {
    fontSize: 25,
    height: 25,
    width: 25,
    alignSelf: 'center',
    marginRight: 10,
  },
  icon: {
    fontSize: 25,
    height: 25,
    marginRight: 25,
    width: 25,
    alignSelf: 'center',
  },
  cardSubtitle: {
    fontFamily: 'FordAntenna-Medium',
    fontSize: 15,
    marginBottom: 5,
  },
  tableHeader: {
    fontFamily: 'FordAntenna-Medium',
    fontSize: 16,
    border: 'none',
  },
  mapContent: {
    borderRadius: 10,
    marginBottom: 20,
  },
  map: {
    borderRadius: 10,
  },
  cardBlock: {
    marginBottom: 20,
  },
  tableBodyCell: {
    '@media (max-width: 767px)': {
      padding: '6px',
    },
    border: 'none',
  },
  bannerButtons: {
    display: 'flex',
    position: 'absolute',
    bottom: 60,
    left: 50,
    padding: 10,
    borderRadius: 10,
    '@media (max-width: 500px)': {
      left: 20,
      bottom: 20,
    },
  },
  bannerVirtualTourButton: {
    padding: 10,
    borderRadius: 10,
    marginRight: 10,
  },
  bannerButton: {
    padding: 10,
    borderRadius: 10,
  },
  bold: {
    fontFamily: 'FordAntenna-SemiBold',
  },
  bodyContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  brokers: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    marginBottom: 20,
  },
  brokerCard: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    borderRadius: 10,
    backgroundColor: COLOR.WHITE,
    '@media (max-width: 767px)': {
      flexDirection: 'column',
      marginBottom: 20,
    },
  },
  brokerDetail: {
    padding: 20,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
  },
  brokerName: {
    fontFamily: 'FordAntenna-SemiBold',
    fontSize: 20,
    marginBottom: 10,
  },
  brokerPhone: {
    fontSize: 16,
    display: 'flex',
    alignItems: 'center',
    marginBottom: 5,
  },
  brokerEmail: {
    fontSize: 16,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'underline',
    marginBottom: 5,
  },
  brokerImage: {
    width: 200,
    height: '100%',
    borderTopLeftRadius: 10,
    borderBottomLeftRadius: 10,
    objectFit: 'cover',
    marginRight: 20,
    '@media (max-width: 767px)': {
      width: '100%',
      borderTopRightRadius: 10,
      borderBottomLeftRadius: 0,
    },
  },
  leftColumn: {
    width: '100%',
  },
  rightColumn: {
    width: '100%',
    padding: 30,
  },
  brokerInfoIcon: {
    width: 20,
    height: 20,
    marginRight: 10,
  },
  brokerWebsite: {
    marginBottom: 5,
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  contactButton: {
    padding: 10,
    alignSelf: 'center',
    borderRadius: 10,
    cursor: 'pointer',
    width: '100%',
    marginTop: 10,
  },
  buttonText: {
    textTransform: 'none',
  },
  mapAddress: {
    fontFamily: 'FordAntenna-Medium',
  },
  description: {
    lineHeight: 1.7,
  },
  addendum: {
    lineHeight: 1.7,
    fontFamily: 'FordAntenna-Light',
  },
  centrisNumber: {
    fontSize: 14,
    marginBottom: 10,
  },
  addressRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '80%',
    margin: 'auto',
    '@media (max-width: 767px)': {
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
    },
  },
  gridRow: {
    textAlign: 'left',
    marginBottom: 20,
    '@media (max-width: 767px)': {
      marginBottom: 10,
    },
  },
  popover: {
    padding: 10,
    marginTop: 5,
  },
  linkButton: {
    padding: 10,
    borderRadius: 10,
  },
  socialMediaContent: {
    marginTop: 20,
    marginBottom: 10,
  },
  mapRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  tableRow: {
    '&:nth-child(2n+1)': {
      backgroundColor: COLOR.ULTRA_LIGHT_GREY,
    },
  },
  accordion: {
    margin: 'auto !important',
    width: '80%',
    '&.MuiAccordion-root:before': {
      backgroundColor: 'transparent',
    },
    '&.MuiPaper-elevation1': {
      boxShadow: 'none',
    },
  },
  accordionSummary: {
    '&.MuiAccordionSummary-root': {
      padding: 0,
    },
    '&.MuiAccordionSummary-content': {
      margin: '20px 0 !important',
    },
    borderRadius: 0,
  },
  accordionSummaryTitle: {
    fontSize: 20,
    textTransform: 'uppercase',
    paddingTop: 10,
    paddingBottom: 10,
  },
  accordionDetails: {
    flexDirection: 'column',
    margin: 'auto !important',
  },
  expandIcon: {
    fontSize: 30,
    paddingTop: 10,
    paddingBottom: 10,
  },
  brokersContent: {
    width: '80%',
    margin: 'auto',
    marginBottom: 20,
    padding: 30,
    borderRadius: 10,
    backgroundColor: COLOR.ULTRA_LIGHT_PURPLE,
  },
  arrowContent: {
    display: 'block',
  },
  expenseContent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: 'auto',
    '@media (max-width: 767px)': {
      justifyContent: 'center',
    },
  },
  expenseDetail: {
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
  },
  expenseRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 10,
  },
  expense: {
    fontFamily: 'FordAntenna-Medium',
    fontSize: 17,
  },
  expenseTotal: {
    fontFamily: 'FordAntenna-Bold',
    fontSize: 17,
  },
  chart: {
    width: 170,
    height: 170,
  },
  divider: {
    marginTop: 5,
    marginBottom: 5,
    backgroundColor: COLOR.GREY,
  },
  tooltipContent: {
    backgroundColor: COLOR.ULTRA_LIGHT_PURPLE,
    borderRadius: 8,
    padding: 10,
  },
  tooltip: {
    fontFamily: 'FordAntenna-Medium',
    fontSize: 16,
  },
  label: {
    fontFamily: 'FordAntenna-Medium',
  },
  buttons: {
    marginLeft: 20,
  },
  calculatorContent: {
    padding: 30,
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 10,
    width: '80%',
    margin: 'auto',
    backgroundColor: COLOR.ULTRA_LIGHT_PURPLE,
  },
  control: {
    flex: '1 1',
    marginBottom: 20,
    '&:last-child': {
      marginBottom: 0,
    },
  },
  selectDropdown: {
    overflow: 'hidden',
  },
  textfield: {
    '& .MuiOutlinedInput-input': {
      padding: 10,
    },
  },
  bannerLeftImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    alignSelf: 'center',
    cursor: 'pointer',
    '@media (max-width: 700px)': {
      height: 400,
    },
  },
  rightImageContainer: {
    height: '50%',
  },
  leftSmallBannerImage: {
    width: '100%',
    height: 'calc((70vh - 84px) / 2)',
    objectFit: 'cover',
    alignSelf: 'center',
    cursor: 'pointer',
  },
  sharePopover: {
    '& .MuiPopover-paper': {
      width: 200,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      padding: '20px 40px',
    },
  },
  shareIcon: {
    marginRight: 5,
    alignSelf: 'center',
  },
  modal: {
    position: 'absolute',
    alignItems: 'center',
    left: '20vw',
    top: '10vh',
    height: '80vh',
    width: '55vw',
    '@media (max-width: 767px)': {
      width: '100vw',
      left: 0,
      top: '20vh',
      height: 'auto',
    },
  },
});

interface Props {
  className?: string;
  centris_listings: Listing[];
  broker: Broker;
  portal_infos?: any;
}

function CentrisListing({ className, centris_listings, broker, portal_infos }: Props) {
  const classes = useStyles();
  const location = useLocation();
  const intl = useIntl();
  const dispatch = useDispatch();
  const language = useLanguage();
  const isEn = language === ENG;
  const { pathname } = location;
  const anchorRef = useRef(null);
  const listing = centris_listings.find((l) => {
    return l.mls === pathname.split('/')[2];
  });
  const rooms = listing?.rooms || [];
  const [currentSlide, setCurrentSlide] = useState<number>(0);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [image_carousel_open, setImageCarouselOpen] = useState(false);
  const [image_carousel_pictures, setImageCarouselPictures] = useState<any[]>(
    listing?.pictures || [],
  );

  const brokers = [];
  if (listing) {
    if (listing?.main_broker) {
      brokers.push(listing.main_broker);
    }
    if (listing?.second_broker) {
      brokers.push(listing.second_broker);
    }
    if (listing?.third_broker) {
      brokers.push(listing.third_broker);
    }
    if (listing?.fourth_broker) {
      brokers.push(listing.fourth_broker);
    }
  }
  const settings = {
    infinite: true,
    arrows: true,
    fade: true,
    dots: false,
    adaptiveHeight: false,
    lazyLoad: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    className: 'react_single_slick_slider_dark',
    beforeChange: (current, next) => {
      setTimeout(() => {
        return setCurrentSlide(next);
      }, 1500);
    },
  };

  const squareFoot = isEn ? 'ft²' : 'pi²';
  const header_bg_color = portal_infos?.template_style?.header_bg_color || COLOR.SECONDARY_BLUE;
  const secondary_color = portal_infos?.template_style?.secondary_color || COLOR.SECONDARY_BLUE;
  const primary_color_contrast_ratio = getColorContrastRatio(
    portal_infos?.template_style?.primary_color,
    COLOR.WHITE,
  );
  const secondary_color_contrast_ratio = getColorContrastRatio(secondary_color, COLOR.WHITE);
  const primary_bg_text_color =
    primary_color_contrast_ratio > COLOR_CONTRAST_RATIO ? COLOR.WHITE : COLOR.BLACK;
  const secondary_bg_text_color =
    secondary_color_contrast_ratio > COLOR_CONTRAST_RATIO ? COLOR.WHITE : COLOR.BLACK;
  const COLORS = [secondary_color];

  const [showDropDown, setShowDropDown] = useState(false);
  const [collapse, setCollapse] = useState({
    buildingDetails: true,
    addendum: true,
    rooms: true,
    inclusions: true,
    expenses: true,
  });
  const [downPaymentType, setDownPaymentType] = useState('dollar');
  const [downpayment, setDownpayment] = useState(null);
  const [downpaymentPercentage, setDownpaymentPercentage] = useState(null);
  const [interestRate, setInterestRate] = useState(5);
  const [amortizationPeriod, setAmortizationPeriod] = useState(25);
  const [paymentFrequency, setPaymentFrequency] = useState(12);
  const [payment, setPayment] = useState(null);

  const data = [];
  if (listing.expenses) {
    listing.expenses.forEach((expense) => {
      data.push({
        name: `${Math.round(Number(expense.amount) / listing.getExpenseTotal())}%`,
        value: Number(expense.amount),
        title: isEn ? expense.type.description_en : expense.type.description_fr,
      });
    });
  }
  const fmtPropertyFeatures = intl.formatMessage({ id: 'portal.propertyFeatures' });
  const fmtRooms = intl.formatMessage({ id: 'portal.rooms' });
  const fmtRoom = intl.formatMessage({ id: 'portal.room' });
  const fmtBeds = intl.formatMessage({ id: 'portal.beds' });
  const fmtBed = intl.formatMessage({ id: 'portal.bed' });
  const fmtBaths = intl.formatMessage({ id: 'portal.baths' });
  const fmtBath = intl.formatMessage({ id: 'portal.bath' });
  const fmtPowderRooms = intl.formatMessage({ id: 'portal.powderRooms' });
  const fmtPowderRoom = intl.formatMessage({ id: 'portal.powderRoom' });
  const fmtYearBuilt = intl.formatMessage({ id: 'portal.builtIn' });
  const fmtLandArea = intl.formatMessage({ id: 'portal.landArea' });
  const fmtBuildingSurfaceArea = intl.formatMessage({ id: 'portal.buildingSurfaceArea' });
  const fmtBuildingDetails = intl.formatMessage({ id: 'portal.buildingDetails' });
  const fmtExteriorFeatures = intl.formatMessage({ id: 'portal.exteriorFeatures' });
  const fmtCloseTo = intl.formatMessage({ id: 'portal.closeTo' });
  const fmtParking = intl.formatMessage({ id: 'portal.parking' });
  const fmtRoomDetails = intl.formatMessage({ id: 'portal.roomDetails' });
  const fmtLevel = intl.formatMessage({ id: 'portal.level' });
  const fmtDimensions = intl.formatMessage({ id: 'portal.dimensions' });
  const fmtFlooring = intl.formatMessage({ id: 'portal.flooring' });
  const fmtMap = intl.formatMessage({ id: 'portal.map' });
  const fmtInclusions = intl.formatMessage({ id: 'portal.inclusions' });
  const fmtExclusions = intl.formatMessage({ id: 'portal.exclusions' });
  const fmtShow = intl.formatMessage({ id: 'portal.show' });
  const fmtPhotos = intl.formatMessage({ id: 'portal.photos' });
  const fmtWebsite = intl.formatMessage({ id: 'portal.website' });
  const fmtContact = intl.formatMessage({ id: 'portal.contactBroker' });
  const fmtAddendum = intl.formatMessage({ id: 'portal.addendum' });
  const fmtDescription = intl.formatMessage({ id: 'portal.description' });
  const fmtMLS = intl.formatMessage({ id: 'portal.mls' });
  const fmtPropertyCategory = intl.formatMessage({ id: 'portal.propertyCategory' });
  const fmtPropertyType = intl.formatMessage({ id: 'portal.propertyType' });
  const fmtBuildingType = intl.formatMessage({ id: 'portal.buildingType' });
  const fmtDetail = intl.formatMessage({ id: 'portal.detail' });
  const fmtOccupationDelay = intl.formatMessage({ id: 'portal.occupationDelay' });
  const fmtTotalUnits = intl.formatMessage({ id: 'portal.totalUnits' });
  const fmtVirtualTour = intl.formatMessage({ id: 'portal.virtualTour' });
  const fmtOpenHouse = intl.formatMessage({ id: 'portal.openHouse' });
  const fmtBrokers = intl.formatMessage({ id: 'portal.brokers' });
  const fmtBroker = intl.formatMessage({ id: 'portal.broker' });
  const fmtInclusionsExclusions = intl.formatMessage({ id: 'portal.inclusionsExclusions' });
  const fmtNoListing = intl.formatMessage({ id: 'portal.noListing' });
  const fmtExpenses = intl.formatMessage({ id: 'portal.annualExpenses' });
  const fmtTotal = intl.formatMessage({ id: 'portal.total' });
  const fmtCalculator = intl.formatMessage({ id: 'portal.calculator' });
  const fmtPropertyPrice = intl.formatMessage({ id: 'portal.propertyPrice' });
  const fmtDownPayment = intl.formatMessage({ id: 'portal.downPayment' });
  const fmtMortgageAmount = intl.formatMessage({ id: 'portal.mortgageAmount' });
  const fmtInterestRate = intl.formatMessage({ id: 'portal.interestRate' });
  const fmtAmortizationPeriod = intl.formatMessage({ id: 'portal.amortizationPeriod' });
  const fmtYears = intl.formatMessage({ id: 'portal.years' });
  const fmtCalculate = intl.formatMessage({ id: 'portal.calculate' });
  const fmtPaymentFrequency = intl.formatMessage({ id: 'portal.paymentFrequency' });
  const fmtMonthly = intl.formatMessage({ id: 'portal.monthly' });
  const fmtBiMonthly = intl.formatMessage({ id: 'portal.biMonthly' });
  const fmtEveryTwoWeeks = intl.formatMessage({ id: 'portal.biWeekly' });
  const fmtWeekly = intl.formatMessage({ id: 'portal.weekly' });
  const fmtPayment = intl.formatMessage({ id: 'portal.paymentAmount' });
  const fmtShare = intl.formatMessage({ id: 'deliver.shareModal.share' });
  const fmtPrint = intl.formatMessage({ id: 'portal.print' });

  const mortgageFrequencyOptions = [
    { value: 12, label: fmtMonthly },
    { value: 24, label: fmtBiMonthly },
    { value: 26, label: fmtEveryTwoWeeks },
    { value: 52, label: fmtWeekly },
  ];

  const onContactBroker = (broker) => {
    if (broker.code === listing.main_broker.code) {
      const form = $('.section.contactform')[0];
      if (form) {
        form.scrollIntoView({ behavior: 'smooth', block: 'end' });
      }
    } else {
      window.location.href = `mailto:${broker?.email}`;
    }
  };

  const calculateMortgage = () => {
    if (downpayment && interestRate && amortizationPeriod && paymentFrequency) {
      const mortgageAmount = listing.getMortgage(downpayment);
      const rate = interestRate / 100 / paymentFrequency;
      const numberOfPayments = amortizationPeriod * paymentFrequency;
      const monthlyPayment = (mortgageAmount * rate) / (1 - (1 + rate) ** -numberOfPayments);
      setPayment(monthlyPayment.toFixed(2));
    }
  };

  const onChangeDownpayment = (value) => {
    if (value > listing.price) {
      return;
    }
    if (value === '') {
      setDownpaymentPercentage(null);
      setDownpayment('');
    } else if (/^-?\d+$/.test(value)) {
      setDownpaymentPercentage(Number((Number(value) / listing.price).toFixed(2)) * 100);
      setDownpayment(Number(value));
    }
  };

  const onChangeDownpaymentRatio = (value) => {
    console.log(11, value, /^-?\d+$/.test(value));
    if (value > 100) {
      return;
    }
    if (value === '') {
      setDownpaymentPercentage(null);
      setDownpayment('');
    } else if (/^-?\d+$/.test(value)) {
      setDownpaymentPercentage(Number(value));
      setDownpayment((Number(value) / 100) * listing.price);
    }
  };

  const onChangeDownpaymentInterestRate = (value) => {
    if (value > 30) {
      return;
    }
    if (value === '') {
      setInterestRate(null);
    } else {
      setInterestRate(Number(value));
    }
  };

  const onChangeAmortizationPeriod = (value) => {
    if (value > 99) {
      return;
    }
    if (value === '') {
      setAmortizationPeriod(null);
    } else if (/^-?\d+$/.test(value)) {
      setAmortizationPeriod(Number(value));
    }
  };

  const onClickShare = (e) => {
    setAnchorEl(anchorEl ? null : e.currentTarget);
  };

  const onChangeFrequency = (value) => {
    setPaymentFrequency(value);
  };
  const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * (Math.PI / 180));
    const y = cy + radius * Math.sin(-midAngle * (Math.PI / 180));

    return (
      <text
        x={x}
        y={y}
        fill='white'
        textAnchor={x > cx ? 'start' : 'end'}
        dominantBaseline='central'
        style={{ fontFamily: 'FordAntenna-Medium' }}
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };
  const renderOpenHouses = () => {
    if (!listing.getOpenHouses().length) {
      return null;
    }
    return (
      <div className={classes.openHousesContent} style={{ backgroundColor: secondary_color }}>
        <Typography className={classes.openHouseTitle} style={{ color: secondary_bg_text_color }}>
          {fmtOpenHouse}
        </Typography>
        {listing.getOpenHouses().map((openHouse) => {
          return (
            <Typography style={{ color: secondary_bg_text_color, textTransform: 'capitalize' }}>
              {`${moment(openHouse?.start_date).format('dddd, Do MMMM YYYY')}: ${moment(
                openHouse?.start_time,
                'HH:mm:ss',
              ).format('HH:mm')} - ${moment(openHouse?.end_time, 'HH:mm:ss').format('HH:mm')}`}
            </Typography>
          );
        })}
      </div>
    );
  };
  const renderPropertyFeatures = () => {
    if (
      !listing.room_count &&
      !listing.bedroom_count &&
      !listing.bathroom_count &&
      !listing.waterroom_count &&
      !listing.construction_year &&
      !listing.living_area &&
      !listing.land_area &&
      !listing.building_surface_area
    ) {
      return null;
    }
    return (
      <div className={classes.card}>
        <Typography
          className={classes.cardTitle}
          style={{
            borderLeft: `4px solid ${secondary_color}`,
            paddingLeft: 5,
          }}
        >
          {fmtPropertyFeatures}
        </Typography>
        <Grid container>
          {listing.room_count && listing.room_count > 0 && (
            <Grid item md={4} sm={12} className={classes.iconRow}>
              <MeetingRoomRoundedIcon className={classes.icon} />
              <Typography className={classes.roomCountText}>
                {`${listing.room_count} ${listing.room_count > 1 ? fmtRooms : fmtRoom}`}
              </Typography>
            </Grid>
          )}
          {listing.bedroom_count && listing.bedroom_count > 0 && (
            <Grid item md={4} sm={12} className={classes.iconRow}>
              <KingBedRoundedIcon className={classes.icon} />
              <Typography className={classes.roomCountText}>
                {`${listing.bedroom_count} ${listing.bedroom_count > 1 ? fmtBeds : fmtBed}`}
              </Typography>
            </Grid>
          )}
          {listing.bathroom_count && listing.bathroom_count > 0 && (
            <Grid item md={4} sm={12} className={classes.iconRow}>
              <FontAwesomeIcon icon={faBath} className={classes.icon} />
              <Typography className={classes.roomCountText}>
                {`${listing.bathroom_count} ${listing.bathroom_count > 1 ? fmtBaths : fmtBath}`}
              </Typography>
            </Grid>
          )}
          {listing.waterroom_count && listing.waterroom_count > 0 && (
            <Grid item md={4} sm={12} className={classes.iconRow}>
              <FontAwesomeIcon icon={faToilet} className={classes.icon} />
              <Typography className={classes.roomCountText}>
                {`${listing.waterroom_count} ${
                  listing.waterroom_count > 1 ? fmtPowderRooms : fmtPowderRoom
                }`}
              </Typography>
            </Grid>
          )}
          {listing.construction_year && (
            <Grid item md={4} sm={12} className={classes.iconRow}>
              <FontAwesomeIcon icon={faCalendar} className={classes.icon} />
              <Typography className={classes.roomCountText}>
                {`${fmtYearBuilt} ${listing.construction_year}`}
              </Typography>
            </Grid>
          )}
          {listing.living_area && listing.living_area > 0 && (
            <Grid item md={4} sm={12} className={classes.iconRow}>
              <FontAwesomeIcon icon={faRulerCombined} className={classes.icon} />
              <Typography className={classes.roomCountText}>
                {`${listing.living_area} ${listing.living_area_unit === 'MC' ? 'm²' : squareFoot}`}
              </Typography>
            </Grid>
          )}
          {listing.land_area && listing.land_area > 0 && (
            <Grid item md={4} sm={12} className={classes.iconRow}>
              <FontAwesomeIcon icon={faRulerCombined} className={classes.icon} />
              <Typography className={classes.roomCountText}>
                {`${fmtLandArea} ${listing.land_area} ${
                  listing.land_area_unit === 'MC' ? 'm²' : squareFoot
                }`}
              </Typography>
            </Grid>
          )}
          {listing.building_surface_area && listing.building_surface_area > 0 && (
            <Grid item md={4} sm={12} className={classes.iconRow}>
              <FontAwesomeIcon icon={faRulerCombined} className={classes.icon} />
              <Typography className={classes.roomCountText}>
                {`${fmtBuildingSurfaceArea} ${listing.building_surface_area} ${
                  listing.building_surface_area_unit === 'MC' ? 'm²' : squareFoot
                }`}
              </Typography>
            </Grid>
          )}
        </Grid>
      </div>
    );
  };
  const renderMap = () => {
    if (!listing.latitude && !listing.longitude) {
      return null;
    }
    return (
      <div className={classes.transparentCard}>
        <Typography
          className={classes.cardTitle}
          style={{
            borderLeft: `4px solid ${secondary_color}`,
            paddingLeft: 5,
          }}
        >
          {fmtMap}
        </Typography>
        {listing.latitude && listing.longitude ? (
          <div className={classes.mapContent}>
            <HvGoogleMap
              className={classes.map}
              lat={Number(listing.latitude)}
              lng={Number(listing.longitude)}
            />
          </div>
        ) : null}
        <div className={classes.mapRow}>
          <RoomIcon className={classes.icon} />
          <Typography className={classes.mapAddress}>{listing.getAddress(language)}</Typography>
        </div>
      </div>
    );
  };
  const renderAddendum = () => {
    if (!listing.getListingAddendum(language).__html) {
      return null;
    }
    return (
      <Accordion
        className={classes.accordion}
        style={{
          borderBottom: `2px solid ${header_bg_color}`,
        }}
      >
        <AccordionSummary
          onClick={() => {
            setCollapse({ ...collapse, addendum: !collapse.addendum });
          }}
          expandIcon={
            collapse.addendum ? (
              <AddRoundedIcon className={classes.expandIcon} style={{ color: header_bg_color }} />
            ) : (
              <RemoveRoundedIcon
                className={classes.expandIcon}
                style={{ color: header_bg_color }}
              />
            )
          }
          className={classes.accordionSummary}
        >
          <Typography className={classes.accordionSummaryTitle}>{fmtAddendum}</Typography>
        </AccordionSummary>
        <AccordionDetails className={classes.accordionDetails}>
          <div
            className={classes.addendum}
            dangerouslySetInnerHTML={listing.getListingAddendum(language)}
          />
        </AccordionDetails>
      </Accordion>
    );
  };
  const renderBuildingDetails = () => {
    if (
      !listing.category &&
      !listing.property_type &&
      !listing.building_type &&
      !listing.occupation_delay_en &&
      !listing.occupation_delay_fr &&
      !listing.getListingTotalUnitCount() &&
      listing.getListingCharacteristics().length > 0 &&
      !listing.parking &&
      !listing.close_to &&
      !listing.no_legal_guarantee
    ) {
      return null;
    }
    return (
      <Accordion
        className={classes.accordion}
        style={{
          borderBottom: `2px solid ${header_bg_color}`,
        }}
      >
        <AccordionSummary
          onClick={() => {
            setCollapse({ ...collapse, buildingDetails: !collapse.buildingDetails });
          }}
          expandIcon={
            collapse.buildingDetails ? (
              <AddRoundedIcon className={classes.expandIcon} style={{ color: header_bg_color }} />
            ) : (
              <RemoveRoundedIcon
                className={classes.expandIcon}
                style={{ color: header_bg_color }}
              />
            )
          }
          className={classes.accordionSummary}
        >
          <Typography className={classes.accordionSummaryTitle}>{fmtBuildingDetails}</Typography>
        </AccordionSummary>
        <AccordionDetails className={classes.accordionDetails}>
          <Grid spacing={1} container className={classes.row}>
            {listing.category && (
              <Grid item md={4} sm={12} className={classes.gridRow}>
                <Typography className={classes.cardSubtitle}>{fmtPropertyCategory}</Typography>
                <Typography className={classes.roomCountText}>
                  {isEn ? listing?.category?.description_en : listing?.category?.description_fr}
                </Typography>
              </Grid>
            )}
            {listing.property_type && (
              <Grid item md={4} sm={12} className={classes.gridRow}>
                <Typography className={classes.cardSubtitle}>{fmtPropertyType}</Typography>
                <Typography className={classes.roomCountText}>
                  {isEn
                    ? listing?.property_type?.description_en
                    : listing?.property_type?.description_fr}
                </Typography>
              </Grid>
            )}
            {listing.building_type && (
              <Grid item md={4} sm={12} className={classes.gridRow}>
                <Typography className={classes.cardSubtitle}>{fmtBuildingType}</Typography>
                <Typography className={classes.roomCountText}>
                  {isEn
                    ? listing?.building_type?.description_en
                    : listing?.building_type?.description_fr}
                </Typography>
              </Grid>
            )}
            {listing.occupation_delay_en || listing.occupation_delay_fr ? (
              <Grid item md={4} sm={12} className={classes.gridRow}>
                <Typography className={classes.cardSubtitle}>{fmtOccupationDelay}</Typography>
                <Typography className={classes.roomCountText}>
                  {isEn ? listing.occupation_delay_en : listing.occupation_delay_fr}
                </Typography>
              </Grid>
            ) : null}
            {listing.getListingTotalUnitCount() > 0 && (
              <Grid item md={4} sm={12} className={classes.gridRow}>
                <Typography className={classes.cardSubtitle}>{fmtTotalUnits}</Typography>
                <Typography className={classes.roomCountText}>
                  {listing.getListingTotalUnitCount()}
                </Typography>
              </Grid>
            )}
            {listing.getListingCharacteristics() &&
              listing.getListingCharacteristics().map((c) => {
                return (
                  <Grid item md={4} sm={12} className={classes.gridRow}>
                    <Typography className={classes.cardSubtitle}>
                      {isEn ? c.type.description_en : c.type.description_fr}
                    </Typography>
                    <Typography className={classes.roomCountText}>
                      {listing.getListingCharacteristicsValues(c.subtypes, c.type.code, language)}
                    </Typography>
                  </Grid>
                );
              })}
            {listing.parking && (
              <Grid item md={4} sm={12} className={classes.gridRow}>
                <Typography className={classes.cardSubtitle}>{fmtParking}</Typography>
                <Typography className={classes.roomCountText}>{listing.parking}</Typography>
              </Grid>
            )}
            {listing.close_to && (
              <Grid item md={4} sm={12} className={classes.gridRow}>
                <Typography className={classes.cardSubtitle}>{fmtCloseTo}</Typography>
                <Typography className={classes.roomCountText}>{listing.close_to}</Typography>
              </Grid>
            )}
          </Grid>
          {listing.no_legal_guarantee && (
            <div className={classes.cardBlock}>
              <Typography className={classes.cardSubtitle}>
                {isEn
                  ? listing.no_legal_guarantee.description_en ||
                    listing.no_legal_guarantee.description_fr
                  : listing.no_legal_guarantee.description_fr ||
                    listing.no_legal_guarantee.description_en}
              </Typography>
            </div>
          )}
        </AccordionDetails>
      </Accordion>
    );
  };
  const renderInclusionsExclusions = () => {
    if (
      !listing.inclusion_en &&
      !listing.inclusion_fr &&
      !listing.exclusion_en &&
      !listing.exclusion_fr
    ) {
      return null;
    }
    return (
      <Accordion
        className={classes.accordion}
        style={{
          borderBottom: `2px solid ${header_bg_color}`,
        }}
      >
        <AccordionSummary
          onClick={() => {
            setCollapse({ ...collapse, inclusions: !collapse.inclusions });
          }}
          expandIcon={
            collapse.inclusions ? (
              <AddRoundedIcon className={classes.expandIcon} style={{ color: header_bg_color }} />
            ) : (
              <RemoveRoundedIcon
                className={classes.expandIcon}
                style={{ color: header_bg_color }}
              />
            )
          }
          className={classes.accordionSummary}
        >
          <Typography className={classes.accordionSummaryTitle}>
            {fmtInclusionsExclusions}
          </Typography>
        </AccordionSummary>
        <AccordionDetails className={classes.accordionDetails}>
          <div>
            {listing.inclusion_en || listing.inclusion_fr ? (
              <div className={classes.cardBlock}>
                <Typography className={classes.cardSubtitle}>{fmtInclusions}</Typography>
                <Typography className={classes.roomCountText}>
                  {isEn
                    ? listing.inclusion_en || listing.inclusion_fr
                    : listing.inclusion_fr || listing.inclusion_en}
                </Typography>
              </div>
            ) : null}
            {listing.exclusion_en || listing.exclusion_fr ? (
              <div className={classes.cardBlock}>
                <Typography className={classes.cardSubtitle}>{fmtExclusions}</Typography>
                <Typography className={classes.roomCountText}>
                  {isEn
                    ? listing.exclusion_en || listing.exclusion_fr
                    : listing.exclusion_fr || listing.exclusion_en}
                </Typography>
              </div>
            ) : null}
          </div>
        </AccordionDetails>
      </Accordion>
    );
  };
  const renderRoomDetails = () => {
    if (!rooms.length) {
      return null;
    }
    return (
      <Accordion
        className={classes.accordion}
        style={{
          borderBottom: `2px solid ${header_bg_color}`,
        }}
      >
        <AccordionSummary
          onClick={() => {
            setCollapse({ ...collapse, rooms: !collapse.rooms });
          }}
          expandIcon={
            collapse.rooms ? (
              <AddRoundedIcon className={classes.expandIcon} style={{ color: header_bg_color }} />
            ) : (
              <RemoveRoundedIcon
                className={classes.expandIcon}
                style={{ color: header_bg_color }}
              />
            )
          }
          className={classes.accordionSummary}
        >
          <Typography className={classes.accordionSummaryTitle}>{fmtRoomDetails}</Typography>
        </AccordionSummary>
        <AccordionDetails className={classes.accordionDetails}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.tableHeader}>{fmtRoom}</TableCell>
                  <TableCell className={classes.tableHeader}>{fmtLevel}</TableCell>
                  <TableCell className={classes.tableHeader}>{fmtDimensions}</TableCell>
                  <TableCell className={classes.tableHeader}>{fmtFlooring}</TableCell>
                  <TableCell className={classes.tableHeader}>{fmtDetail}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rooms.map((r: CentrisRoom) => {
                  const room = new CentrisRoom(r);
                  const detail_en = room.additional_information || room.additional_information_fr;
                  const detail_fr = room.additional_information_fr || room.additional_information;
                  const detail = isEn ? detail_en : detail_fr;
                  return (
                    <TableRow key={room.id} className={classes.tableRow}>
                      <TableCell className={classes.tableBodyCell}>
                        {room.getRoomName(language)}
                      </TableCell>
                      <TableCell className={classes.tableBodyCell}>
                        {room.getFloor(language)}
                      </TableCell>
                      <TableCell className={classes.tableBodyCell}>
                        {room.getRoomDimensions(language)}
                      </TableCell>
                      <TableCell className={classes.tableBodyCell}>
                        {room.getFloorType(language)}
                      </TableCell>
                      <TableCell className={classes.tableBodyCell}>{detail}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </AccordionDetails>
      </Accordion>
    );
  };
  const renderCustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className={classes.tooltipContent}>
          <Typography className={classes.tooltip}>
            {`${payload[0].payload.title}: $${payload[0].value}`}
          </Typography>
        </div>
      );
    }
    return null;
  };
  const renderExpenses = () => {
    if (!listing.expenses.length) {
      return null;
    }
    return (
      <Accordion className={classes.accordion}>
        <AccordionSummary
          onClick={() => {
            setCollapse({ ...collapse, expenses: !collapse.expenses });
          }}
          expandIcon={
            collapse.expenses ? (
              <AddRoundedIcon className={classes.expandIcon} style={{ color: header_bg_color }} />
            ) : (
              <RemoveRoundedIcon
                className={classes.expandIcon}
                style={{ color: header_bg_color }}
              />
            )
          }
          className={classes.accordionSummary}
        >
          <Typography className={classes.accordionSummaryTitle}>{fmtExpenses}</Typography>
        </AccordionSummary>
        <AccordionDetails className={classes.accordionDetails}>
          <Grid container spacing={1} className={classes.expenseContent}>
            <Grid className={classes.expenseDetail} item md={5} sm={12}>
              {listing.expenses.map((expense) => {
                const amount = isEn ? `$${expense.amount}` : `${expense.amount}$`;
                let title = isEn ? expense.type.description_en : expense.type.description_fr;
                if (expense.year) {
                  title += `(${expense.year})`;
                }
                return (
                  <div className={classes.expenseRow}>
                    <Typography className={classes.expense}>{title}</Typography>
                    <Typography className={classes.expense}>{amount}</Typography>
                  </div>
                );
              })}
              <Divider className={classes.divider} />
              <div className={classes.expenseRow}>
                <Typography className={classes.expense}>{`${fmtTotal}: `}</Typography>
                <Typography className={classes.expenseTotal}>
                  {isEn ? `$${listing.getExpenseTotal()}` : `${listing.getExpenseTotal()}$`}
                </Typography>
              </div>
            </Grid>
            <Grid item md={5} sm={12} className={classes.chart}>
              <ResponsiveContainer width='100%' height='100%'>
                <PieChart width={400} height={400}>
                  <Pie
                    data={data}
                    cx='50%'
                    cy='50%'
                    labelLine={false}
                    label={renderCustomizedLabel}
                    outerRadius={80}
                    dataKey='value'
                    isAnimationActive={false}
                    style={{ outline: 'none' }}
                  >
                    {data.map((entry, index) => {
                      return (
                        <Cell
                          key={`cell-${index}`}
                          name={entry.name}
                          fill={COLORS[index % COLORS.length]}
                          strokeWidth={2}
                        />
                      );
                    })}
                  </Pie>
                  <PieTooltip content={renderCustomTooltip} />
                </PieChart>
              </ResponsiveContainer>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    );
  };

  const renderCalculator = () => {
    return (
      <div className={classes.calculatorContent}>
        <Typography
          className={classes.cardTitle}
          style={{
            borderLeft: `4px solid ${secondary_color}`,
            paddingLeft: 5,
          }}
        >
          {fmtCalculator}
        </Typography>
        <div className={classes.cardBlock}>
          <div className={classes.cardBlock}>
            <Typography className={classes.cardSubtitle}>{fmtPropertyPrice}</Typography>
            <TextField
              variant='outlined'
              className={classes.textfield}
              value={listing.getFormattedPrice()}
              InputProps={{
                endAdornment: <InputAdornment position='start'>$</InputAdornment>,
              }}
            />
          </div>
          <div className={classes.cardBlock}>
            <div className={classes.row}>
              <Typography className={classes.cardSubtitle}>{fmtDownPayment}</Typography>
              <div className={classes.buttons}>
                <Button
                  onClick={() => {
                    return setDownPaymentType('dollar');
                  }}
                  style={{
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    backgroundColor: downPaymentType === 'dollar' ? secondary_color : 'white',
                    color: downPaymentType === 'dollar' ? secondary_bg_text_color : secondary_color,
                  }}
                >
                  $
                </Button>
                <Button
                  style={{
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                    backgroundColor: downPaymentType === 'percentage' ? secondary_color : 'white',
                    color:
                      downPaymentType === 'percentage' ? secondary_bg_text_color : secondary_color,
                  }}
                  onClick={() => {
                    return setDownPaymentType('percentage');
                  }}
                >
                  %
                </Button>
              </div>
            </div>
            <div className={classes.row}>
              <TextField
                className={classes.textfield}
                variant='outlined'
                type='number'
                value={downpayment}
                onChange={(e) => {
                  onChangeDownpayment(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'e' || e.key === '.' || e.key === '-') {
                    e.preventDefault();
                  }
                }}
                disabled={downPaymentType === 'percentage'}
                style={{ marginRight: 10 }}
                InputProps={{
                  inputProps: {
                    readOnly: downPaymentType === 'percentage',
                    step: 1,
                    min: 0,
                    max: listing.price,
                  },
                  endAdornment: <InputAdornment position='start'>$</InputAdornment>,
                }}
              />
              <TextField
                className={classes.textfield}
                variant='outlined'
                type='number'
                value={downpaymentPercentage}
                onChange={(e) => {
                  onChangeDownpaymentRatio(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'e' || e.key === '.' || e.key === '-') {
                    e.preventDefault();
                  }
                }}
                disabled={downPaymentType === 'dollar'}
                InputProps={{
                  inputProps: {
                    readOnly: downPaymentType === 'dollar',
                    step: 1,
                    min: 0,
                    max: 100,
                  },
                  endAdornment: <InputAdornment position='start'>%</InputAdornment>,
                }}
              />
            </div>
            <Typography className={classes.cardSubtitle}>{fmtMortgageAmount}</Typography>
            <div className={classes.row}>
              <TextField
                variant='outlined'
                className={classes.textfield}
                value={listing.getMortgage(downpayment)}
                InputProps={{
                  endAdornment: <InputAdornment position='start'>$</InputAdornment>,
                }}
              />
            </div>
            <div className={classes.row}>
              <div>
                <Typography className={classes.cardSubtitle}>{fmtInterestRate}</Typography>
                <TextField
                  variant='outlined'
                  className={classes.textfield}
                  type='number'
                  value={interestRate}
                  onChange={(e) => {
                    onChangeDownpaymentInterestRate(e.target.value);
                  }}
                  style={{ marginRight: 10 }}
                  InputProps={{
                    inputProps: {
                      min: 0,
                      max: 30,
                    },
                    endAdornment: <InputAdornment position='start'>%</InputAdornment>,
                  }}
                />
              </div>
              <div>
                <Typography className={classes.cardSubtitle}>{fmtAmortizationPeriod}</Typography>
                <TextField
                  className={classes.textfield}
                  variant='outlined'
                  type='number'
                  value={amortizationPeriod}
                  onChange={(e) => {
                    onChangeAmortizationPeriod(e.target.value);
                  }}
                  style={{ marginRight: 10 }}
                  InputProps={{
                    inputProps: {
                      min: 1,
                      max: 99,
                      step: 1,
                    },
                    endAdornment: <InputAdornment position='start'>{fmtYears}</InputAdornment>,
                  }}
                />
              </div>
              <div>
                <Typography className={classes.cardSubtitle}>{fmtPaymentFrequency}</Typography>
                <HvSelect
                  classes={{ rootClass: classes.control, dropdownClass: classes.selectDropdown }}
                  options={mortgageFrequencyOptions}
                  value={String(paymentFrequency) || '0'}
                  onChange={onChangeFrequency}
                />
              </div>
            </div>
            <Button
              style={{ backgroundColor: secondary_color, color: secondary_bg_text_color }}
              onClick={calculateMortgage}
            >
              <Typography className={classes.buttonText}>{fmtCalculate}</Typography>
            </Button>
          </div>
          {payment && (
            <div>
              <Typography className={classes.cardSubtitle}>{fmtPayment}</Typography>
              <TextField
                className={classes.textfield}
                variant='outlined'
                type='number'
                value={payment}
                InputProps={{
                  endAdornment: <InputAdornment position='start'>$</InputAdornment>,
                }}
              />
            </div>
          )}
        </div>
      </div>
    );
  };

  const getSocialMediaIcon = (type) => {
    switch (type) {
      case 'FACEBOOK':
        return faFacebook;
      case 'INSTAGRAM':
        return faInstagram;
      case 'LINKEDIN':
        return faLinkedinIn;
      case 'TWITTER':
        return faTwitter;
      case 'YOUTUBE':
        return faYoutube;
      default:
        return faGlobe;
    }
  };
  const renderSocialMediaLinks = (links) => {
    if (!links.length) {
      return null;
    }
    return (
      <div className={classes.socialMediaContent}>
        {links.map((link) => {
          return (
            <Tooltip title={isEn ? link.type.description_en : link.type.description_fr}>
              <FontAwesomeIcon
                icon={getSocialMediaIcon(link.type.short_description_en)}
                className={classes.icon}
                onClick={() => {
                  return window.open(link.social_media_link, '_blank');
                }}
              />
            </Tooltip>
          );
        })}
      </div>
    );
  };
  const renderBrokers = () => {
    if (!brokers.length) {
      return null;
    }
    return (
      <div className={classes.brokersContent}>
        <Typography
          className={classes.cardTitle}
          style={{
            borderLeft: `4px solid ${secondary_color}`,
            paddingLeft: 5,
          }}
        >
          {brokers.length === 1 ? fmtBroker : fmtBrokers}
        </Typography>
        <Grid container className={classes.brokers}>
          {brokers.map((broker) => {
            return (
              <Grid item md={5} sm={12} className={classes.brokerCard}>
                <img className={classes.brokerImage} src={broker.photo_url} alt='broker' />
                <div className={classes.brokerDetail}>
                  <div>
                    <Typography className={classes.brokerName}>
                      {`${broker?.firstname} ${broker?.lastname}`}
                    </Typography>
                    <Typography>{broker?.title}</Typography>
                    <Typography className={classes.brokerPhone}>
                      <FontAwesomeIcon icon={faPhone} className={classes.brokerInfoIcon} />
                      {getPhoneNumberWithFormatting(broker?.main_phone)}
                    </Typography>
                    <Typography
                      className={classes.brokerEmail}
                      onClick={() => {
                        window.location.href = `mailto:${broker?.email}`;
                      }}
                    >
                      <FontAwesomeIcon icon={faEnvelope} className={classes.brokerInfoIcon} />
                      {broker?.email}
                    </Typography>
                    {broker?.website ? (
                      <Typography
                        className={classes.brokerWebsite}
                        onClick={() => {
                          return window.open(broker.website, '_blank');
                        }}
                      >
                        <FontAwesomeIcon icon={faGlobe} className={classes.brokerInfoIcon} />
                        {fmtWebsite}
                      </Typography>
                    ) : null}
                    {broker?.social_media_links?.length > 0 &&
                      renderSocialMediaLinks(broker.social_media_links)}
                  </div>
                  <Button
                    className={classes.contactButton}
                    style={{
                      backgroundColor: secondary_color,
                      color: secondary_bg_text_color,
                    }}
                    onClick={() => {
                      return onContactBroker(broker);
                    }}
                  >
                    <Typography className={classes.buttonText}>{fmtContact}</Typography>
                  </Button>
                </div>
              </Grid>
            );
          })}
        </Grid>
      </div>
    );
  };
  const renderImagesGrid = () => {
    return (
      <Grid container style={{ display: isMobile() ? 'none' : 'flex' }}>
        <Grid item md={6}>
          <Grid container direction='row'>
            <Grid item md={6} style={{ paddingRight: 4 }}>
              <Grid container direction='column'>
                <Grid item md={12}>
                  <img
                    src={listing.pictures[0].url}
                    key={listing.pictures[0].id}
                    className={classes.leftSmallBannerImage}
                    alt='house'
                    onClick={() => {
                      setImageCarouselPictures(listing.pictures);
                      setImageCarouselOpen(true);
                    }}
                  />
                </Grid>
                <Grid item md={12}>
                  <img
                    src={listing.pictures[1].url}
                    key={listing.pictures[1].id}
                    className={classes.leftSmallBannerImage}
                    alt='house'
                    onClick={() => {
                      setImageCarouselOpen(true);
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={6}>
              <img
                src={listing.pictures[2].url}
                key={listing.pictures[2].id}
                className={classes.bannerImage}
                alt='house'
                onClick={() => {
                  setImageCarouselPictures(listing.pictures);
                  setImageCarouselOpen(true);
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item md={6}>
          <Grid container direction='column'>
            <Grid item md={12} className={classes.rightImageContainer}>
              <img
                src={listing.pictures[3].url}
                key={listing.pictures[3].id}
                className={classes.bannerSmallImage}
                alt='house'
                onClick={() => {
                  setImageCarouselPictures(listing.pictures);
                  setImageCarouselOpen(true);
                }}
              />
            </Grid>
            <Grid item md={12}>
              <img
                src={listing.pictures[4].url}
                key={listing.pictures[4].id}
                className={classes.bannerSmallImage}
                alt='house'
                onClick={() => {
                  setImageCarouselPictures(listing.pictures);
                  setImageCarouselOpen(true);
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  };
  if (!listing) {
    return <NotFound reason={fmtNoListing} />;
  }
  return (
    <div className={classes.content} style={{ color: primary_bg_text_color }}>
      <div>
        <div className={classes.bannerImageContainer}>
          {isMobile() ? (
            <Slider {...settings}>
              {listing?.pictures?.length &&
                listing?.pictures.map((item, index) => {
                  return (
                    <div
                      key={index}
                      onClick={() => {
                        return setImageCarouselOpen(true);
                      }}
                    >
                      <img src={item.url} key={index} className={classes.bannerImage} alt='house' />
                      <div className={classes.overlay} />
                    </div>
                  );
                })}
            </Slider>
          ) : null}
          {renderImagesGrid()}
          <div className={classes.bannerButtons}>
            {listing.getListingLinks().length === 1 ? (
              <Button
                onClick={() => {
                  setShowDropDown(false);
                  return window.open(
                    isEn
                      ? listing.getListingLinks()[0].link_en
                      : listing.getListingLinks()[0].link_fr,
                    '_blank',
                  );
                }}
                style={{ backgroundColor: secondary_color, color: secondary_bg_text_color }}
                className={classes.bannerVirtualTourButton}
              >
                <Typography className={classes.buttonText}>
                  {isEn
                    ? listing.getListingLinks()[0]?.type?.description_en
                    : listing.getListingLinks()[0]?.type?.description_fr}
                </Typography>
              </Button>
            ) : null}
            {listing.getListingLinks().length > 1 ? (
              <Button
                className={classes.bannerVirtualTourButton}
                onClick={() => {
                  setShowDropDown(!showDropDown);
                }}
                ref={anchorRef}
                style={{ backgroundColor: secondary_color, color: secondary_bg_text_color }}
              >
                <Typography className={classes.buttonText}>{fmtVirtualTour}</Typography>
                <FontAwesomeIcon icon={faChevronDown} className={classes.arrowIcon} />
              </Button>
            ) : null}
            <Popover
              open={showDropDown}
              anchorEl={anchorRef.current}
              className={classes.popover}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
              onClose={() => {
                return setShowDropDown(false);
              }}
            >
              {listing.getListingLinks().map((l) => {
                return (
                  <Button
                    onClick={() => {
                      setShowDropDown(false);
                      return window.open(isEn ? l.link_en : l.link_fr, '_blank');
                    }}
                    className={classes.linkButton}
                  >
                    <Typography className={classes.buttonText}>
                      {isEn ? l?.type?.description_en : l?.type?.description_fr}
                    </Typography>
                  </Button>
                );
              })}
            </Popover>
            {listing.pictures.length > 0 ? (
              <Button
                className={classes.bannerButton}
                style={{ backgroundColor: secondary_color, color: secondary_bg_text_color }}
                onClick={() => {
                  setImageCarouselPictures(listing.pictures);
                  setImageCarouselOpen(true);
                }}
              >
                <FontAwesomeIcon icon={faCamera} className={classes.buttonIcon} />
                <Typography className={classes.buttonText}>
                  <span className={classes.bold}>{listing.pictures.length}</span>
                  {` ${fmtPhotos}`}
                </Typography>
              </Button>
            ) : null}
          </div>
        </div>
        <div className={classes.bodyContent}>
          <div className={classes.addressRow}>
            <div className={classes.detailContent}>
              <Typography className={classes.propertyType}>
                {listing.getListingType(language)}
              </Typography>
              <div className={classes.iconRow}>
                <RoomIcon className={classes.brokerInfoIcon} />
                <Typography className={classes.address}>{listing.getAddress(language)}</Typography>
              </div>
              <Typography className={classes.centrisNumber}>
                {`${fmtMLS}: ${listing.mls}`}
              </Typography>
            </div>
            <div>
              <Button onClick={onClickShare}>
                <ShareIcon className={classes.shareIcon} />
                <Typography className={classes.buttonText}>{fmtShare}</Typography>
              </Button>
              <Popover
                open={Boolean(anchorEl)}
                className={classes.sharePopover}
                anchorEl={anchorEl}
                onClose={() => {
                  return setAnchorEl(null);
                }}
              >
                <FacebookShareButton url={window.location.href}>
                  <FacebookIcon size={30} round />
                </FacebookShareButton>
                <TwitterShareButton url={window.location.href}>
                  <TwitterIcon size={30} round />
                </TwitterShareButton>
                <LinkedinShareButton url={window.location.href}>
                  <LinkedinIcon size={30} round />
                </LinkedinShareButton>
                <WhatsappShareButton url={window.location.href}>
                  <WhatsappIcon size={30} round />
                </WhatsappShareButton>
              </Popover>
              <Typography className={classes.price}>{listing.getDisplayPrice(language)}</Typography>
            </div>
          </div>
          {renderOpenHouses()}
          {renderPropertyFeatures()}
          {listing.getListingDescription(language) ? (
            <div className={classes.transparentCard}>
              <Typography
                className={classes.cardTitle}
                style={{
                  borderLeft: `4px solid ${secondary_color}`,
                  paddingLeft: 5,
                }}
              >
                {fmtDescription}
              </Typography>
              <Typography className={classes.description}>
                {listing.getListingDescription(language)}
              </Typography>
            </div>
          ) : null}
          {renderBrokers()}
          {renderMap()}
          {renderAddendum()}
          {renderBuildingDetails()}
          {renderInclusionsExclusions()}
          {renderRoomDetails()}
          {renderExpenses()}
          {renderCalculator()}
        </div>
        <Modal open={image_carousel_open}>
          <div className={classes.modal}>
            <ImagesGallery
              pictures={image_carousel_pictures}
              setImageCarouselOpen={setImageCarouselOpen}
              setImageCarouselPictures={setImageCarouselPictures}
            />
          </div>
        </Modal>
      </div>
    </div>
  );
}

export default CentrisListing;
